module.exports = __webpack_public_path__ + "img/2_deal_maker.f3791006.png";